exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rw-login-form\n{\n\n}\n\n.full-width {\n  width: 85%;\n\n}\n\n.customer-fields {\n  margin: 5px;\n  padding: 5px;\n}\n\n.outlinebutton\n{\n  border:solid 1px rgba(249, 168, 37, 0.48);\n  font-size: 12px;\n  border-radius: 10px;\n\n}\n\n.confirmButtons {\n  padding-right: 20px;\n  border-radius: 9px;\n  outline: none;\n}\n\n.verificationSentText{\n  color: #807e7e;\n  padding-left: 10px;\n}\n\n.small-link {\n  /*color: #337ab7;*/\n  /* font-style: italic; */\n  font-variant: small-caps;\n  font-size: 12px;\n  /*text-decoration: underline;*/\n  cursor: pointer;\n  border: solid 1px rgb(205, 209, 213);\n  border-radius: 10px;\n\n}\n\n.info-text{\n  color: #807e7e;\n}\n\n\n@media only screen and (max-width: 767px) {\n  .forgot-password-button {\n    padding-top: 10px;\n  }\n\n\n\n}\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/login-form/login-form.style.css
// module id = 1168
// module chunks = 0